import React from 'react';
import * as R from 'ramda';
import { Typography } from '@mui/material';
import { t_loading } from './Product';
import { TEXT_LOADING_URL_DOWNLOADING, TEXT_LOADING_URL_FAILED } from './const';

export default function LoadingBgImage(props: { loading: t_loading }) {
	return (
		<Typography variant='body2' color='textSecondary'>
			{text(props.loading)}
		</Typography>
	);
}

const text = R.cond([
	[R.equals('LOADING'), R.always(TEXT_LOADING_URL_DOWNLOADING)],
	[R.equals('SUCCESS'), R.always('')],
	[R.equals('FAILED'), R.always(TEXT_LOADING_URL_FAILED)],
	[R.T, R.always('')],
]);
